/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemFolderWrapper_item = {
    readonly serviceId: string | null;
    readonly folderPortfolioItems?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"Folder_folderPortfolioItems">;
    } | null> | null;
    readonly " $refType": "ItemFolderWrapper_item";
};
export type ItemFolderWrapper_item$data = ItemFolderWrapper_item;
export type ItemFolderWrapper_item$key = {
    readonly " $data"?: ItemFolderWrapper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemFolderWrapper_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemFolderWrapper_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "loadPortfolioData",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "loadPortfolioData",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "folderPortfolioItems",
          "name": "portfolioItems",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "portfolioType",
              "value": "FOLDER"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "PortfolioItemV2",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "Folder_folderPortfolioItems",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '4866fa2e4af049da61e235003e0dc744';
export default node;
